import { Avatar, Stack, Typography } from '@mui/material';

interface IRecommendationInformation {
  title: string;
  description: string;
  icon: string;
}

export const RecommendationInformation = ({
  title,
  description,
  icon,
}: IRecommendationInformation) => {
  return (
    <Stack
      direction='row'
      gap='16px'
      sx={{
        ml: '20px',
      }}
    >
      <Avatar alt='' src={icon} />
      <Stack gap='8px'>
        <Typography variant='body1'>{title}</Typography>
        <Typography
          variant='body6'
          dangerouslySetInnerHTML={{ __html: description }}
          sx={{
            '&  a': {
              color: 'primary.main',
              fontWeight: 600,
            },
          }}
        />
      </Stack>
    </Stack>
  );
};
